import React from 'react';
import classnames from 'classnames';
import { CnLoading } from '@cainiaofe/cn-ui';
import './index.scss';
import { RequestError } from '../request-error';

export default function WrapperContainer({
  children,
  className,
  style = {},
  loading,
  skeletonVisible,
  skeletonNode,
  error,
  nodeId,
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  loading?: boolean;
  skeletonVisible?: boolean;
  skeletonNode?: React.ReactNode;
  error?: string;
  nodeId?: string;
}) {
  const renderLoading = () => {
    if (!skeletonVisible && loading) {
      return (
        <div
          className="cn-wrapper-container-loading"
          data-component="easyinsight"
          data-nodeId={nodeId}
        >
          <CnLoading visible tip="" />
        </div>
      );
    }

    return null;
  };

  const renderMain = () => {
    if (skeletonVisible) {
      return skeletonNode;
    }

    if (error) {
      return <RequestError error={error} />;
    }

    return children;
  };

  return (
    <div
      className={classnames('cn-wrapper-container', className)}
      style={{
        ...style,
      }}
      data-component="easyinsight"
      data-nodeId={nodeId}
    >
      {renderLoading()}
      {renderMain()}
    </div>
  );
}
